export default __webpack_public_path__ + "static/media/LaserSintererImg.625683ea.jpg";